import de from 'date-fns/locale/de'
import enUS from 'date-fns/locale/en-US'
import fr from 'date-fns/locale/fr'
import it from 'date-fns/locale/it'
import { getWindow } from '../helpers/Window'

import {
  ActiveServicesKindEnum,
  CarDamageValue,
  ContractStateEnum,
  Environment,
  LocaleEnum,
  ProductTypeEnum,
  VehicleNatureValue,
} from './enums'
import { GridSettings } from '../hooks/useSettings'

export const window = getWindow()

const { hostname } = window.location

const mobileVersionsToMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i]

const url2envMap: Readonly<Record<string, Environment>> = Object.freeze({
  localhost: Environment.Development,
  '4u-stg.interfleet.ch': Environment.Staging,
  '4u-demo.interfleet.ch': Environment.Demo,
  '4u-int.interfleet.ch': Environment.Integration,
  '4u.interfleet.ch': Environment.Production,
})

//useSettings defaults
export interface UserSettings {
  lang: string
  i4uGrids: Record<string, GridSettings | undefined>
  excludeRestrictedDocuments: 'y' | 'n'
  contractCostsInterval: { from: string; to: string; contractId: string } | undefined
  contractSupportRef: string | [string, string]
  lastSeenRelease: string
  expiringDaysFilter: string
  selectedManager: string
}

export const DEFAULT_SETTINGS: UserSettings = {
  lang: 'de',
  i4uGrids: {},
  excludeRestrictedDocuments: 'y',
  contractCostsInterval: undefined,
  contractSupportRef: '',
  lastSeenRelease: '',
  expiringDaysFilter: '30',
  selectedManager: '',
}

export const defaultLanguage = 'en'

export const newItemId = 'new'
export const noCostCenter = 'No cost center'

export const carMakes = [
  {
    name: 'Abarth',
    value: 'Abarth',
  },
  {
    name: 'Alfa-Romeo',
    value: 'Alfa-Romeo',
  },
  {
    name: 'Aston-Martin',
    value: 'Aston-Martin',
  },
  {
    name: 'Audi',
    value: 'Audi',
  },
  {
    name: 'Bentley',
    value: 'Bentley',
  },
  {
    name: 'BMW',
    value: 'BMW',
  },
  {
    name: 'Cadillac',
    value: 'Cadillac',
  },
  {
    name: 'Chevrolet',
    value: 'Chevrolet',
  },
  {
    name: 'Chrysler',
    value: 'Chrysler',
  },
  {
    name: 'Citroen',
    value: 'Citroen',
  },
  {
    name: 'Cupra',
    value: 'Cupra',
  },
  {
    name: 'Dacia',
    value: 'Dacia',
  },
  {
    name: 'Daihatsu',
    value: 'Daihatsu',
  },
  {
    name: 'Dodge',
    value: 'Dodge',
  },
  {
    name: 'DS',
    value: 'DS',
  },
  {
    name: 'Dummy',
    value: 'Dummy',
  },
  {
    name: 'Ferrari',
    value: 'Ferrari',
  },
  {
    name: 'Fiat',
    value: 'Fiat',
  },
  {
    name: 'Ford',
    value: 'Ford',
  },
  {
    name: 'Hyundai',
    value: 'Hyundai',
  },
  {
    name: 'Honda',
    value: 'Honda',
  },
  {
    name: 'Honda-moto',
    value: 'Honda-moto',
  },
  {
    name: 'Infiniti',
    value: 'Infiniti',
  },
  {
    name: 'Isuzu',
    value: 'Isuzu',
  },
  {
    name: 'Iveco',
    value: 'Iveco',
  },
  {
    name: 'Jaguar',
    value: 'Jaguar',
  },
  {
    name: 'Jeep',
    value: 'Jeep',
  },
  {
    name: 'Kia',
    value: 'Kia',
  },
  {
    name: 'Lamborghini',
    value: 'Lamborghini',
  },
  {
    name: 'Lancia',
    value: 'Lancia',
  },
  {
    name: 'Land-rover',
    value: 'Land-rover',
  },
  {
    name: 'Lexus',
    value: 'Lexus',
  },
  {
    name: 'MAN',
    value: 'MAN',
  },
  {
    name: 'Maserati',
    value: 'Maserati',
  },
  {
    name: 'Mazda',
    value: 'Mazda',
  },
  {
    name: 'Mercedes-benz',
    value: 'Mercedes-benz',
  },
  {
    name: 'Mercedes-amg',
    value: 'Mercedes-amg',
  },
  {
    name: 'MG',
    value: 'MG',
  },
  {
    name: 'Mini',
    value: 'Mini',
  },
  {
    name: 'Mitsubishi',
    value: 'Mitsubishi',
  },
  {
    name: 'Mitsubishi-fuso',
    value: 'Mitsubishi-fuso',
  },
  {
    name: 'Nissan',
    value: 'Nissan',
  },
  {
    name: 'Opel',
    value: 'Opel',
  },
  {
    name: 'Peugeot',
    value: 'Peugeot',
  },
  {
    name: 'Peugeot-motocycles',
    value: 'Peugeot-motocycles',
  },
  {
    name: 'Piaggio',
    value: 'Piaggio',
  },
  {
    name: 'Polestar',
    value: 'Polestar',
  },
  {
    name: 'Porsche',
    value: 'Porsche',
  },
  {
    name: 'Renault',
    value: 'Renault',
  },
  {
    name: 'SAAB',
    value: 'SAAB',
  },
  {
    name: 'Seat',
    value: 'Seat',
  },
  {
    name: 'Skoda',
    value: 'Skoda',
  },
  {
    name: 'Smart',
    value: 'Smart',
  },
  {
    name: 'Ssangyong',
    value: 'Ssangyong',
  },
  {
    name: 'Subaru',
    value: 'Subaru',
  },
  {
    name: 'Suzuki',
    value: 'Suzuki',
  },
  {
    name: 'Tesla',
    value: 'Tesla',
  },
  {
    name: 'Toyota',
    value: 'Toyota',
  },
  {
    name: 'Volkswagen',
    value: 'Volkswagen',
  },
  {
    name: 'Volvo',
    value: 'Volvo',
  },
  {
    name: 'VW',
    value: 'VW',
  },
]

export const PL001 = 'PL001' // Pool car?

export const internalUser = '594cd817-6de7-4575-b8ee-f93860db0cf8'

export const supplierRoleId = '911d0007-8805-4d2c-a338-c9aad3e337b2'

export const adminRoleId = '66a86ef7-2a61-489b-b5c0-bfe617527385'

export const managerRoleId = '1625be50-89e9-4aab-97c1-0d59c0f082d2'

export const guestRoleId = 'c5f44132-0b33-4372-bcfb-d00ff46ee695'

export const emptyGuid = '00000000-0000-0000-0000-000000000000'

export const paletteForMakesCharts = [
  '#cbc87b',
  '#c1c47c',
  '#b7c07c',
  '#aebd7d',
  '#a4b97d',
  '#9ab57e',
  '#a2aa79',
  '#ab9f74',
  '#b39470',
  '#bb896b',
  '#c47e66',
  '#cc7361',
  '#d4685d',
  '#dd5d58',
  '#e55253',
  '#d85053',
  '#cb4f53',
  '#be4d53',
  '#b24b53',
  '#a54952',
  '#984852',
  '#8b4652',
  '#7e4452',
  '#8b5455',
  '#996457',
  '#a6735a',
  '#b3835d',
  '#c0935f',
  '#cea362',
  '#dbb264',
  '#e8c267',
  '#d6b469',
  '#c4a66b',
  '#b1976d',
  '#9f896f',
  '#8d7b71',
  '#7b6d73',
  '#685e75',
  '#565077',
  '#595b7e',
  '#5b6784',
  '#5e728b',
  '#617e92',
  '#638998',
  '#66949f',
  '#68a0a5',
  '#6babac',
  '#73a2a7',
  '#7c98a2',
  '#848f9c',
  '#8c8697',
  '#947c92',
  '#9d738d',
  '#a56987',
  '#ad6082',
  '#b57a80',
  '#bc947f',
  '#c4ae7d',
  '#c7b289',
  '#d0bc8f',
  '#d9c795',
  '#e2d09b',
  '#ebd9a1',
  '#f4e2a7',
  '#fdebbd',
  '#fbf1b8',
  '#f9e7b4',
  '#f8ddb0',
  '#f6d3ac',
  '#f4c9a8',
  '#f3bfa4',
  '#f1b5a0',
  '#efab9c',
  '#eea198',
  '#eca794',
  '#ea9d90',
  '#e9938c',
  '#e78988',
]

export const languages = ['en', 'de', 'fr', 'it']

export const productTypeIdDict = Object.freeze<Partial<Record<string, ProductTypeEnum>>>({
  '200046': ProductTypeEnum.GM,
  '200160': ProductTypeEnum.FullOpen,
  '200168': ProductTypeEnum.Mo,
  '208251': ProductTypeEnum.Mo,
  // BE authorisation actuall has 217279 under FullClosed. Label on FE is changed to MoClose on purpose
  // #9082
  '217279': ProductTypeEnum.MoClosed,
  '217258': ProductTypeEnum.Medlease,
  '217266': ProductTypeEnum.GM,
  '217272': ProductTypeEnum.FullClosed,
  '217275': ProductTypeEnum.FullDistance,
  '217276': ProductTypeEnum.EFLLagerfinanzierungPhase1,
  '207012': ProductTypeEnum.GMLeasingGold,
  '217280': ProductTypeEnum.ExternalFin,
  '217278': ProductTypeEnum.Fin,
  '200007': ProductTypeEnum.Fin,
  '217289': ProductTypeEnum.Fin,
  '217293': ProductTypeEnum.Fin,
  '200169': ProductTypeEnum.Fin,
  '200127': ProductTypeEnum.Fin,
  '217290': ProductTypeEnum.FinPlus,
  '200097': ProductTypeEnum.FinPlus,
  '200130': ProductTypeEnum.FinPlus,
  '200086': ProductTypeEnum.FullClosed,
  '214935': ProductTypeEnum.FullClosed,
  '217287': ProductTypeEnum.FullClosed,
  '200191': ProductTypeEnum.FullOpen,
  '217286': ProductTypeEnum.FullOpen,
  '200117': ProductTypeEnum.FullOpenPlus,
  '217288': ProductTypeEnum.FullOpenPlus,
  '200008': ProductTypeEnum.Mo,
  '208252': ProductTypeEnum.MoClosed,
  '217299': ProductTypeEnum.MoClosed,
  '200118': ProductTypeEnum.MoClosed,
  '217305': ProductTypeEnum.SimpleXFleet,
  '200156': ProductTypeEnum.Mitarbeiterleasing,
})

export const productTypeIdMap = new Map(Object.entries(productTypeIdDict))

export const tagsForNewDC = 'DeltaContractNew'

export const allowedContractStatusesForAdminActive = [
  ContractStateEnum.Running,
  ContractStateEnum.Extended,
  ContractStateEnum.Initialized,
]

export const allowedContractStatusesForAdminAll = [
  ContractStateEnum.Closed,
  ContractStateEnum.Running,
  ContractStateEnum.Terminated,
  ContractStateEnum.Extended,
  ContractStateEnum.Initialized,
  ContractStateEnum.Canceled,
  ContractStateEnum.Ordered,
]

export const monthNames = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
]

export const vehicleNatureValuesDict = Object.freeze({
  Passenger: VehicleNatureValue.Passenger,
  LightCommercial: VehicleNatureValue.LightCommercial,
  HeavyCommercial: VehicleNatureValue.HeavyCommercial,
  Motorcycle: VehicleNatureValue.Motorcycle,
  Bicycle: VehicleNatureValue.Bicycle,
  Other: VehicleNatureValue.Other,
  DeliveryTruck: VehicleNatureValue.DeliveryTruck,
  Truck: VehicleNatureValue.Truck,
  AlsoPassenger: VehicleNatureValue.AlsoPassenger,
  AlsoMotorcycle: VehicleNatureValue.AlsoMotorcycle,
  Undefined: VehicleNatureValue.Undefined,
  ChargingStation: VehicleNatureValue.ChargingStation,
  Trailer: VehicleNatureValue.Trailer,
})

export const damagesTranslations = Object.freeze({
  Diebstahl: 'THEFT',
  Elemtarschaden: 'NATURAL_HAZARDS',
  'Glass breakage': 'GLASS_BREAKAGE',
  Hagelschaden: 'DAMAGE_HAIL',
  'Kollision mit Fahrzeug': 'COLLISION_CAR',
  'Kollision mit fixem Objekt': 'COLLISION_OBJECT',
  'Kollision mit Tier': 'COLLISION_ANIMAL',
  Marderschaden: 'DAMAGE_MARTENS',
  Parkschaden: 'PARKING_DAMAGE',
  Vandalismus: 'VANDALISM',
  null: 'NO_DAMAGE',
  Personenschaden: 'COLLISION_PEOPLE',
})

export const indidentStatusTranslations = Object.freeze({
  'erledigt/geschlossen': 'CLOSED',
})

export const damageTypeValuesDict = Object.freeze({
  THEFT: CarDamageValue.Theft,
  NATURAL_HAZARDS: CarDamageValue.NaturalHazard,
  GLASS_BREAKAGE: CarDamageValue.GlassBreakage,
  DAMAGE_HAIL: CarDamageValue.HailDamage,
  COLLISION_CAR: CarDamageValue.CollisionWithCar,
  COLLISION_OBJECT: CarDamageValue.CollisionWithObject,
  COLLISION_ANIMAL: CarDamageValue.CollisionWithAnimal,
  DAMAGE_MARTENS: CarDamageValue.MartenDamage,
  PARKING_DAMAGE: CarDamageValue.ParkingDamage,
  VANDALISM: CarDamageValue.Vandalism,
  NO_DAMAGE: CarDamageValue.NoDamage,
  COLLISION_PEOPLE: CarDamageValue.CollisionWithPeople,
})

export const vehicleNatureValuesDictGerman = Object.freeze({
  Personenwagen: VehicleNatureValue.Passenger,
  Lieferwagen: VehicleNatureValue.DeliveryTruck,
  undefiniert: VehicleNatureValue.Undefined,
})

export const activeServicesIconsDict = Object.freeze<Record<string, string | undefined>>({
  Rmt: ActiveServicesKindEnum.Rmt,
  General: ActiveServicesKindEnum.General,
  Transport: ActiveServicesKindEnum.Transport,
  ReliefVehicle: ActiveServicesKindEnum.ReliefVehicle,
  ReplacementCar: ActiveServicesKindEnum.ReliefVehicle,
  Fuel: ActiveServicesKindEnum.Fuel,
  RoadTax: ActiveServicesKindEnum.RoadTax,
  Insurance: ActiveServicesKindEnum.Insurance,
  // 'Fee': ActiveServicesKindEnum.Fee,
  Maintenance: ActiveServicesKindEnum.Maintenance,
  Tires: ActiveServicesKindEnum.Tires,
  Vignette: ActiveServicesKindEnum.Vignette,
  // AilLiabilitActiveServicesKindEnum.
  AilLiability: ActiveServicesKindEnum.AilLiability,
  AilKasko: ActiveServicesKindEnum.AilKasko,
  LiabilityHandling: ActiveServicesKindEnum.Liability,
  KaskoHandling: ActiveServicesKindEnum.Kasko,
  Liability: ActiveServicesKindEnum.Liability,
  // (blank)ActiveServicesKindEnum.
  Kasko: ActiveServicesKindEnum.Kasko,
  // BlanActiveServicesKindEnum.
  CarWash: ActiveServicesKindEnum.CarWash,
  MobilitySharingLicense: ActiveServicesKindEnum.MobilitySharingLicense,
  OnSiteService: ActiveServicesKindEnum.OnSiteService,
  Refurbishment: ActiveServicesKindEnum.Refurbishment,
  Reestablishment: ActiveServicesKindEnum.Reestablishment,
})

export const langLocaleMap = Object.freeze({
  en: LocaleEnum.En,
  de: LocaleEnum.De,
  it: LocaleEnum.It,
  fr: LocaleEnum.Fr,
})

export const langTranslationMap = Object.freeze({
  en: 'ENGLISH',
  de: 'GERMAN',
  it: 'ITALIAN',
  fr: 'FRENCH',
})

export const installReqClasses = Object.freeze({
  required: 'req-y',
  left: 'left-true',
  right: 'right-true',
  middle: 'middle-true',
})

export const dateFnsLocaleMap = Object.freeze({
  en: enUS,
  de,
  it,
  fr,
})

export const approvalStepsStatuses = Object.freeze({
  pending: 'Pending',
  approved: 'Approved',
  declined: 'Declined',
})

export const mobileVersion = mobileVersionsToMatch.some((toMatchItem) => {
  return navigator.userAgent.match(toMatchItem)
})

export const environment: Environment = url2envMap[hostname] || Environment.Unknown
export const isDev: boolean = environment === Environment.Development
export const isDemo: boolean = environment === Environment.Demo
export const isStaging: boolean = environment === Environment.Staging
export const isDevAndStaging: boolean = isDev || isStaging
export const isIntegration: boolean = environment === Environment.Integration
export const isProduction: boolean = environment === Environment.Production
